import React, { useRef, useState } from "react";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { getRelativePath } from "../Helpers/uploaderAPI.js";
import useLightboxOpenPreview from "../Helpers/useLightboxOpenPreview.js";
import { CircularProgressbar } from "react-circular-progressbar";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import VideoPreviewModal from "../Reusable/VideoPreviewModal.js";
import useCreatePreview from "../Helpers/useCreatePreview.js";
import useFileProgress from "../Helpers/useFileProgress.js";

const UploadListItem = ({ file, progress }) => {
  const { uploaderRemoveFile, getUploading, getIsUppy } = useUploader();

  const fileObj = getIsUppy() ? file : file.file;

  const { isComplete, isError, persentegeProgress } = useFileProgress(
    file,
    progress
  );

  const preview = useCreatePreview(fileObj, fileObj.type);

  const { handleOpenLightbox } = useLightboxOpenPreview(fileObj);

  const [hover, setHover] = useState(false);

  const hoverRef = useRef(null);

  const size = bytesToDisplayHelper(file.size);
  const name = getRelativePath(fileObj)
    ? getRelativePath(fileObj) + "/" + file.name
    : file.name;

  return (
    <div className="list-file-item" key={file.id}>
      <VideoPreviewModal
        hover={hover}
        preview={preview}
        fileType={fileObj.type}
        fileRef={hoverRef}
        middleTop={true}
      />
      <div
        ref={hoverRef}
        className="list-file-name"
        onClick={handleOpenLightbox}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        {name}
      </div>
      <div className="flex-spacer" />
      <div className="list-file-info">{size.size + size.type}</div>
      {getUploading() ? (
        <div className="list-file-info">
          {isComplete ? (
            <Icon name="check" green />
          ) : isError ? (
            <Icon name="warning" red />
          ) : (
            <CircularProgressbar
              value={persentegeProgress}
              text={persentegeProgress}
              counterClockwise={true}
            />
          )}
        </div>
      ) : null}
      {getUploading() ? null : (
        <div className="list-file-info">
          <div
            className="close-icon"
            onClick={() => {
              uploaderRemoveFile(file.id);
            }}
          >
            <Icon name={"x"} darkGray />
          </div>
        </div>
      )}
    </div>
  );
};
export default UploadListItem;
